// src/main.js
import './axios' // ważne: na początku, żeby interceptor działał

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'

import { translate } from '@/locales/lang' // tylko funkcja translate

const app = createApp(App)
app.config.globalProperties.$t = translate

// ===== [SPA Analytics] =====

// FB Pixel – czy dostępny
function fbqAvailable () {
  return typeof window !== 'undefined' && typeof window.fbq === 'function'
}
// GA4 – czy dostępny
function gtagAvailable () {
  return typeof window !== 'undefined' && typeof window.gtag === 'function'
}

// Każda zmiana routa = PageView (Pixel) + page_view (GA4)
router.afterEach((to) => {
  // Meta Pixel
  try {
    if (fbqAvailable()) {
      window.fbq('track', 'PageView')
      // (opcjonalnie) dodatkowy event:
      // window.fbq('trackCustom', 'SPA_Navigation', { path: to.fullPath })
    }
  } catch (e) { /* no-op */ }

  // Google Analytics 4
  try {
    if (gtagAvailable()) {
      window.gtag('event', 'page_view', {
        page_path: to.fullPath,
        page_location: (typeof window !== 'undefined'
          ? window.location.origin + to.fullPath
          : to.fullPath),
        page_title: document.title
      })
    }
  } catch (e) { /* no-op */ }
})

// ===== [/SPA Analytics] =====

app.use(router)
app.mount('#app')
